

export var PD:any = {};

export const statusLookup:any = {
    "None" : {
        'severity' : 'danger',
        'score' : 0,
    },
    "Implemented" : {
        'severity' : 'success',
        'score' : 1,
    },
    "Inherited" : {
        'severity' : 'success',
        'score' : 1,
    },
    "Planned" : {
        'severity' : 'warning',
        'score' : 0.25,
    },
    "Not Applicable" : {
        'severity' : 'info',
        'score' : 1,
    },
}


export default function DataManagement(props:any){
    return(
        <></>
    )
}